import { cssVar, setCssVar } from '@helpers/cssVar';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';
import SiteWide from '../Global/SiteWide/SiteWide';
const Container = styled.section `
  color: ${cssVar('fgColor')};
  ${setCssVar('sectionMargin', '32px')};

  @media ${from(Device.TabletLarge)} {
    ${setCssVar('sectionMargin', '80px')};
  }

  ${({ flush, padding }) => css `
    ${padding
    ? css `
          padding-top: ${cssVar('sectionMargin')};
          padding-bottom: ${cssVar('sectionMargin')};
        `
    : css `
          margin-top: ${cssVar('sectionMargin')};
          margin-bottom: ${cssVar('sectionMargin')};
        `}

    ${() => flush === 'top' &&
    css `
        margin-top: 0;
        padding-top: 0;
      `}

    ${() => flush === 'bottom' &&
    css `
        margin-bottom: 0;
        padding-bottom: 0;
      `}

    ${() => flush === 'both' &&
    css `
        margin-top: 0;
        margin-bottom: 0;
        padding-top: 0;
        padding-bottom: 0;
      `}
  `}
`;
const StyledSiteWide = styled(SiteWide) ``;
export default {
    Container,
    SiteWide: StyledSiteWide,
};
